import html2canvas from 'html2canvas';

export async function exportAsImage(element, filename = 'export.png') {
    if (!element) {
        throw new Error('Nothing to capture for image export.');
    }

    const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false,
    });

    const link = document.createElement('a');
    link.download = filename.endsWith('.png') ? filename : `${filename}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
}
